import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import {I18n} from '../../I18n/components/createCompany';

const CompanyTypeSelector = props => {
    const {lang} = props;
    const companyLabels = {
        RETAIL: I18n[lang].stepOne.companyTraders,
        DEVELOP: I18n[lang].stepOne.companyDev,
        OPERATOR: I18n[lang].stepOne.companyOperator
    };
    const options = [
        {value: 'RETAIL', label: companyLabels.RETAIL},
        {value: 'DEVELOP', label: companyLabels.DEVELOP},
        {value: 'OPERATOR', label: companyLabels.OPERATOR}
    ];

    const defaultValue = options.reduce((values, elem) => {
        if (props.types.includes(elem.value)) {
            values.push({
                value: elem.value,
                label: companyLabels[elem.value]
            });
        }
        return values;
    }, []);
    return (
        <Select
            className={props.className ? `companyTypeSelect ${props.className}` : null}
            name={props.name}
            closeMenuOnSelect={true}
            value={defaultValue}
            options={options}
            onChange={data => {
                props.onCompanyTypeChange(data);
            }}
            onBlur={props.validation}
            isDisabled={props.isDisabled}
            styles={{
                control: (styles, {data, isSelected}) => ({
                    ...styles,
                    color: '#3e5569',
                    //backgroundColor: 'white',
                    borderColor: '#e9ecef'
                }),
                singleValue: (styles, {data}) => ({
                    ...styles,
                    color: '#3e5569'
                }),
            }}
        />
    )
};

CompanyTypeSelector.propTypes = {
    name: PropTypes.string,
    onCompanyTypeChange: PropTypes.func
};

export default CompanyTypeSelector;


// WEBPACK FOOTER //
// ./src/components/Company/CompanyTypeSelector.js